import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";

const PostlistBanner = (props) => {
  const [bannerInfo, setBannerInfo] = useState();

  useEffect(() => {
    props.gameList.forEach((game) => {
      if (game.game_id === props.selectGameId) {
        setBannerInfo(game);
      }
    });
  }, [props]);

  return (
    <>
      {bannerInfo && (
        <div className="banner__content">
          <img
            className="banner__img"
            src={require(`../../../assets/img/${bannerInfo.banner_url}`)}
            alt="banner"
          />
          <div className="banner__infos">
            <div className="banner__top">
              <Dropdown className="banner__dropdown">
                <Dropdown.Toggle as={"button"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    className="svg-inline--fa fa-chevron-left fa-w-10"
                    data-icon="chevron-left"
                    data-prefix="fas"
                    viewBox="0 0 320 512"
                  >
                    <path
                      fill="#fff"
                      d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                    ></path>
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Header>Choisir un jeu</Dropdown.Header>
                  <ul>
                    {props.gamesList &&
                      props.gamesList.map((value, key) => (
                        <Dropdown.Item
                          as={"li"}
                          onClick={() => {
                            props.setSelectGame(value.game);
                            props.setSelectGameId(value.game_id);
                          }}
                          key={key}
                        >
                          {value.game}
                        </Dropdown.Item>
                      ))}
                  </ul>
                </Dropdown.Menu>
              </Dropdown>
              <h2 className="banner__title">{bannerInfo.game} </h2>
            </div>

            <span className="banner__nbrPost">
              {bannerInfo.nbr_posts} annonce{bannerInfo.nbr_posts > 1 && "s"}
            </span>
            {!props.disconnected && (
              <button
                onClick={() => props.setNewPostTrigger(true)}
                className="banner__discoverBtn"
              >
                Créer une annonce
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PostlistBanner;
